import { render, staticRenderFns } from "./self.vue?vue&type=template&id=bb2dc3b0&"
import script from "./self.vue?vue&type=script&lang=js&"
export * from "./self.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports